import { css } from 'lit';

// these styles can be imported from any component
// for an example of how to use this, check /pages/about-about.ts
export const styles = css`
  :host {
        display: flex;
        height: 100%;


    }

    aside {
        height: 100%;
        width: 170px;
        border-right: 1px solid #222;
        padding: 10px;
        overflow-y: scroll;

        ul {
            padding-bottom: 20px;
        }

        ul,
        li {
            list-style: none;
            margin: 0;
            padding: 0;
            width: 100%;
            cursor: pointer;

            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            p,
            a {
                margin: 0;
            }

            &.active {
                a {
                    p:first-child {
                        font-weight: bold;
                    }
                }
            }

            a {
                text-decoration: none;
                color: #eee;
                font-size: 0.9em;
                padding: 0;
                border-radius: 4px;
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 1px;

                p {
                    position: relative;
                    display: inline-block;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 100%;
                    overflow: hidden;

                    small {
                        opacity: 0.5;
                    }
                }

                &:hover,
                &:focus {
                    color: #fff;
                }

                svg {
                    width: 1.2rem
                }
            }

            h4 {
                font-size: 0.8em;
                text-transform: uppercase;
                color: #888;
            }
        }

        ul {
            display: flex;
            flex-direction: column;
            gap: 15px;
            padding-bottom: 30px;

            li {
                .active {
                    color: red;
                }
            }
        }
    }
`;